export interface StoreProduct {
  id: string;
  type: 'book' | 'app';
  title: string;
  image: string;
  price: string;
  priceNum: number;
  category: string;
  subCategory: string;
  description: string;
  badge?: string;
  rating?: number;
  reviews?: number;
  amazonUrl?: string;
  paymentLink: string;
  downloadUrl?: string;
}

const GODADDY_PAYMENT_LINK = 'https://e001e9ac-68a7-4c40-b8ea-95640b3298a4.paylinks.godaddy.com/afa25c0a-1b07-44ce-adb7-5b5';

export const storeProducts: StoreProduct[] = [
  // ── BOOKS ────────────────────────────────────────────────────────────────
  {
    id: 'book-1',
    type: 'book',
    title: 'Infinite Banking Concept: How to Turn Your Life Insurance Policy into Your Bank',
    image: 'https://m.media-amazon.com/images/I/61wWWN27GbL._SY522_.jpg',
    price: '$7.89',
    priceNum: 7.89,
    category: 'book',
    subCategory: 'Finance & Banking',
    description: 'Discover how to leverage your whole life insurance policy as a personal banking system to build wealth and financial independence.',
    rating: 3.8,
    reviews: 12,
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Infinite-banking-concept-insurance-policy-ebook/dp/B09FSB1M2P',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-2',
    type: 'book',
    title: 'The Infinite Banking Blueprint: Unlocking Your Life Insurance Potential',
    image: 'https://m.media-amazon.com/images/I/61blvlwskkL._SY522_.jpg',
    price: '$12.89',
    priceNum: 12.89,
    category: 'book',
    subCategory: 'Finance & Banking',
    description: 'A deep-dive blueprint for using infinite banking strategies to grow, protect, and multiply your wealth with life insurance.',
    rating: 3.9,
    reviews: 2,
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Infinite-Banking-Blueprint-Unlocking-Insurance-ebook/dp/B0DKX7BVL2',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-3',
    type: 'book',
    title: 'Mastering AI-Powered Trading Bots for Options',
    image: 'https://m.media-amazon.com/images/I/61SiUx+cM6L._SY522_.jpg',
    price: '$29.89',
    priceNum: 29.89,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'Learn how to build and deploy AI-driven trading bots to analyze massive datasets and execute options strategies faster than any human can.',
    rating: 5.0,
    reviews: 1,
    badge: 'Bestseller',
    amazonUrl: 'https://www.amazon.com/Mastering-AI-Powered-Trading-Bots-Options-ebook/dp/B0CXVF4333',
    paymentLink: GODADDY_PAYMENT_LINK,
    downloadUrl: 'https://storage.readdy-site.link/project_files/6b9c5ca9-dc2c-4e89-ba67-0fa3ab6fb382/1a53b2f1-68cd-41a7-92b0-432f9015f96b_mastering-ai-powered-trading-bots-for-options_6654ae85.pdf?v=30a8c44547446072ad9aecb198dacad0',
  },
  {
    id: 'book-4',
    type: 'book',
    title: 'Tax Sales Overages: Who Took My Money',
    image: 'https://m.media-amazon.com/images/I/81cVcPL2wrL._SY522_.jpg',
    price: 'Free',
    priceNum: 0,
    category: 'book',
    subCategory: 'Real Estate',
    description: 'Uncover the hidden world of tax sale overages and learn how to claim money that rightfully belongs to property owners.',
    rating: 3.3,
    reviews: 5,
    badge: 'Kindle Unlimited',
    amazonUrl: 'https://www.amazon.com/Tax-Sales-Overages-Took-Money-ebook/dp/B09J38W4HD',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-5',
    type: 'book',
    title: 'How to Use Infinite Banking to Purchase Tax Lien Foreclosures',
    image: 'https://m.media-amazon.com/images/I/81nLKp4gWPL._SY522_.jpg',
    price: '$7.68',
    priceNum: 7.68,
    category: 'book',
    subCategory: 'Finance & Banking',
    description: 'Combine infinite banking principles with tax lien investment strategies to build a powerful real estate portfolio.',
    rating: 3.0,
    reviews: 4,
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Infinite-Banking-Purchase-Lien-Foreclosure-ebook/dp/B09GRTLFPX',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-6',
    type: 'book',
    title: 'The Prosperity Puzzle: The Joy of Achieving Financial Prosperity',
    image: 'https://m.media-amazon.com/images/I/716PJmyATeL._SY522_.jpg',
    price: '$23.79',
    priceNum: 23.79,
    category: 'book',
    subCategory: 'Business Development',
    description: 'Piece together the secrets of financial prosperity through mindset shifts, strategic planning, and actionable wealth-building habits.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Prosperity-Puzzle-Joy-Achieving-Financial-ebook/dp/B0DP23YZ96',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-7',
    type: 'book',
    title: "The First-Time Author's Playbook: Navigating the Publishing World",
    image: 'https://m.media-amazon.com/images/I/71Xl8K9+1cL._SY522_.jpg',
    price: '$12.89',
    priceNum: 12.89,
    category: 'book',
    subCategory: 'Business Development',
    description: 'Everything a first-time author needs to know: writing, publishing, marketing, and building an author brand from scratch.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/First-Time-Authors-Playbook-Navigating-Publishing-ebook/dp/B0D78325LG',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-8',
    type: 'book',
    title: 'Embracing Your Why: A Guide to Finding Purpose in Life',
    image: 'https://m.media-amazon.com/images/I/719eflVmMaL._SY522_.jpg',
    price: '$8.78',
    priceNum: 8.78,
    category: 'book',
    subCategory: 'Personal Growth',
    description: 'A transformative guide to discovering your core purpose, aligning your actions with your values, and living a fully intentional life.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Embracing-Your-Why-Finding-Purpose-ebook/dp/B0DKQR2MHH',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-9',
    type: 'book',
    title: 'AI Investing For Gen Z (AI Series By Jeffery Long Book 2)',
    image: 'https://m.media-amazon.com/images/I/81nnbJjTVtL._SY522_.jpg',
    price: '$8.69',
    priceNum: 8.69,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'Tailored for the next generation of investors, this book covers AI-driven tools and strategies to build wealth in the digital age.',
    badge: 'Series Book 2',
    amazonUrl: 'https://www.amazon.com/Investing-Gen-Jeffery-Long-Book-ebook/dp/B0DGX7M77G',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-10',
    type: 'book',
    title: 'Living with AI: Practical Tools for Beginners (AI Series Book 1)',
    image: 'https://m.media-amazon.com/images/I/81qA2TElv0L._SY522_.jpg',
    price: '$17.89',
    priceNum: 17.89,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'A beginner-friendly introduction to integrating AI tools into everyday life — from productivity to creative work and beyond.',
    badge: 'Series Book 1',
    amazonUrl: 'https://www.amazon.com/Living-AI-Practical-Beginners-Jeffery-ebook/dp/B0DF4XLJ1Q',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-11',
    type: 'book',
    title: 'Advanced Techniques For Using AI to Master Crypto',
    image: 'https://m.media-amazon.com/images/I/81V2FA+iguL._SY522_.jpg',
    price: '$48.89',
    priceNum: 48.89,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'Advanced AI methodologies for crypto market analysis, automated trading, risk management, and portfolio optimization.',
    badge: 'Advanced',
    amazonUrl: 'https://www.amazon.com/Advanced-Techniques-Using-Master-Crypto-ebook/dp/B0DDWWJBV7',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-12',
    type: 'book',
    title: 'The AI Investor: Strategies for Secure Crypto Purchases',
    image: 'https://m.media-amazon.com/images/I/81eV9Pks63L._SY522_.jpg',
    price: '$28.88',
    priceNum: 28.88,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'A comprehensive guide to using AI-powered analysis tools for making safer, more informed cryptocurrency investment decisions.',
    rating: 3.4,
    reviews: 3,
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/AI-Investor-Strategies-Secure-Purchases-ebook/dp/B0DDBMLR36',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-13',
    type: 'book',
    title: 'AI Insights: Automating Your Crypto Research for Smarter Investments',
    image: 'https://m.media-amazon.com/images/I/816ET6rcuEL._SY522_.jpg',
    price: '$28.88',
    priceNum: 28.88,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'Automate your crypto research workflow with AI tools, sentiment analysis, and data-driven investment frameworks.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/AI-Insights-Automating-Research-Investments-ebook/dp/B0DDBGG2Q8',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-14',
    type: 'book',
    title: 'Write The Vision and Make it Plain: A Practical Guide to Achieving Your Dreams',
    image: 'https://m.media-amazon.com/images/I/814YtQAMSFL._SY522_.jpg',
    price: 'Free',
    priceNum: 0,
    category: 'book',
    subCategory: 'Personal Growth',
    description: 'Turn your dreams into a clear, actionable vision with this step-by-step guide to goal-setting, planning, and purposeful execution.',
    badge: 'Kindle Unlimited',
    amazonUrl: 'https://www.amazon.com/Write-Vision-Make-Plain-Practical-ebook/dp/B0DCGFYJL7',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-15',
    type: 'book',
    title: 'AI Future Fortunes: AI-Powered Trends for Long-Term Investors',
    image: 'https://m.media-amazon.com/images/I/81O8dKwx3iL._SY522_.jpg',
    price: '$25.98',
    priceNum: 25.98,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'Identify and capitalize on long-term AI-driven investment trends across stocks, ETFs, and emerging technology sectors.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Future-Fortunes-AI-Powered-Long-Term-Investors-ebook/dp/B0D8GMHBB1',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-16',
    type: 'book',
    title: 'Mastering AI for Business: A Comprehensive Guide to AI in the Modern Workplace',
    image: 'https://m.media-amazon.com/images/I/81xKpQzVJeL._SY522_.jpg',
    price: '$39.89',
    priceNum: 39.89,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'The definitive business leader\'s guide to adopting, scaling, and maximizing the ROI of artificial intelligence in any organization.',
    badge: 'Comprehensive Guide',
    amazonUrl: 'https://www.amazon.com/Mastering-Business-Comprehensive-Artificial-Intelligence-ebook/dp/B0D6LTDYD5',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-17',
    type: 'book',
    title: 'Artificial Intelligence for Stock Traders: How XGPT is Changing the Game',
    image: 'https://m.media-amazon.com/images/P/B0D6KSW41D.01.L.jpg',
    price: '$9.99',
    priceNum: 9.99,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'Harness the power of XGPT AI to revolutionize your stock trading strategy — from algorithmic analysis to machine-learning-driven decisions for beginners and pros alike.',
    rating: 5.0,
    reviews: 3,
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/dp/B0D6KSW41D',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-18',
    type: 'book',
    title: 'The AI Super Boom: The Future of AI — Investing in the Super Boom (AI Series Book 3)',
    image: 'https://m.media-amazon.com/images/P/B0CWFHM5K1.01.L.jpg',
    price: '$29.89',
    priceNum: 29.89,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'The third book in the AI Series — a forward-looking guide to investing ahead of the AI super boom, identifying high-growth sectors and future opportunities in the AI economy.',
    rating: 5.0,
    reviews: 1,
    badge: 'Series Book 3',
    amazonUrl: 'https://www.amazon.com/dp/B0CWFHM5K1',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-19',
    type: 'book',
    title: 'Trading in the Digital Age: The Power of AI in Stock Selection',
    image: 'https://m.media-amazon.com/images/P/B0D53ZGLJL.01.L.jpg',
    price: '$9.99',
    priceNum: 9.99,
    category: 'book',
    subCategory: 'AI & Technology',
    description: 'Discover how AI is transforming modern stock selection and trading. A practical guide using data-driven tools, algorithms, and market analysis to sharpen your investment edge.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/dp/B0D53ZGLJL',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-20',
    type: 'book',
    title: 'The Journey Of The Book: Volume 1',
    image: 'https://m.media-amazon.com/images/P/B09FRZ3NJM.01.L.jpg',
    price: '$7.49',
    priceNum: 7.49,
    category: 'book',
    subCategory: 'Personal Growth',
    description: "Follow Ryan's journey as a soldier and the lessons he learned from reading one powerful book — lessons he shared with a surgeon who saved his life. A quick, inspiring read about the transcending power of storytelling.",
    rating: 5.0,
    reviews: 2,
    badge: 'Series Book 1',
    amazonUrl: 'https://www.amazon.com/Journey-Book-1-Jeffery-Long-ebook/dp/B09FRZ3NJM',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-21',
    type: 'book',
    title: 'The Journey Of The Book 2: Journey Lines Volume 2',
    image: 'https://m.media-amazon.com/images/P/B09G8V34RW.01.L.jpg',
    price: '$7.69',
    priceNum: 7.69,
    category: 'book',
    subCategory: 'Personal Growth',
    description: 'The tale of how one book can change not only hands but lives. People with backgrounds as different as East and West are united by one transcending and powerful force — the words of one book.',
    rating: 5.0,
    reviews: 1,
    badge: 'Series Book 2',
    amazonUrl: 'https://www.amazon.com/Journey-Book-Lines-ebook/dp/B09G8V34RW',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-22',
    type: 'book',
    title: 'The Journey Of The Book Continues: A Story of How The Bible Is Shared and Passed Down Person to Person',
    image: 'https://m.media-amazon.com/images/P/B09JXSHTHQ.01.L.jpg',
    price: '$7.89',
    priceNum: 7.89,
    category: 'book',
    subCategory: 'Personal Growth',
    description: 'Book 3 in the series. Stories based on the best-selling book of all time — how one book can change lives across backgrounds as different as East and West, united by the transcending and powerful words of one book.',
    badge: 'Series Book 3',
    amazonUrl: 'https://www.amazon.com/Journey-Continues-Shared-Passed-Person-ebook/dp/B09JXSHTHQ',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-23',
    type: 'book',
    title: 'Cash Is King But The King Is Dead: The Digital Revolution, How Cash Is Losing its Crown',
    image: 'https://m.media-amazon.com/images/P/B0CYMYXTNZ.01.L.jpg',
    price: '$7.98',
    priceNum: 7.98,
    category: 'book',
    subCategory: 'Finance & Banking',
    description: 'Money has evolved from bartering to digital currency. As contactless payments and cryptocurrency surge, cash is losing its crown. Explore the fascinating journey of money and the digital revolution reshaping how we transact.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Cash-King-But-Dead-Revolution-ebook/dp/B0CYMYXTNZ',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'book-24',
    type: 'book',
    title: 'Mediterranean Magic Recipes: Delicious Recipes for Every Home Cook',
    image: 'https://m.media-amazon.com/images/P/B0CYS29JVF.01.L.jpg',
    price: '$7.98',
    priceNum: 7.98,
    category: 'book',
    subCategory: 'Cooking & Food',
    description: 'Bring the vibrant flavors of the Mediterranean to your kitchen. From Greek to Italian, Spanish, and Middle Eastern cuisine — recipes packed with nutrients and bold flavors for every home cook, regardless of skill level.',
    badge: 'Kindle Edition',
    amazonUrl: 'https://www.amazon.com/Mediterranean-Magic-Recipes-Delicious-Recipes-ebook/dp/B0CYS29JVF',
    paymentLink: GODADDY_PAYMENT_LINK,
  },

  // ── APPS ─────────────────────────────────────────────────────────────────
  {
    id: 'app-1',
    type: 'app',
    title: 'Meeting Recorder Pro',
    image: 'https://public.readdy.ai/ai/img_res/fd93aa4a8f1bfe1245ff8b0435c50dd4.jpg',
    price: '$2.99',
    priceNum: 2.99,
    category: 'app',
    subCategory: 'Productivity',
    description: 'Record, transcribe & export your meetings with on-device AI transcription. Works seamlessly on iPhone and Apple Watch.',
    badge: 'iPhone + Apple Watch',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-2',
    type: 'app',
    title: 'Schedule Boss',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20employee%20scheduling%20and%20shift%20management%20app%2C%20vibrant%20orange%20and%20warm%20coral%20gradient%20background%2C%20white%20calendar%20grid%20with%20checkmark%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20icon%2C%20modern%20flat%20design%20aesthetic&width=400&height=400&seq=app-schedule-boss&orientation=squarish',
    price: '$4.99',
    priceNum: 4.99,
    category: 'app',
    subCategory: 'Productivity',
    description: 'Employee scheduling, shift swapping, and time tracking built for small businesses. Simple, powerful, and mobile-first.',
    badge: 'Small Business',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-3',
    type: 'app',
    title: 'Focus Forest',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20focus%20and%20productivity%20timer%20app%20inspired%20by%20growing%20trees%2C%20lush%20green%20and%20emerald%20forest%20gradient%20background%2C%20white%20minimal%20tree%20sapling%20icon%2C%20clean%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20nature-inspired%20digital%20art&width=400&height=400&seq=app-focus-forest&orientation=squarish',
    price: '$1.99',
    priceNum: 1.99,
    category: 'app',
    subCategory: 'Health & Wellness',
    description: 'Grow a virtual tree while you work or study. Your tree dies if you quit — a beautiful way to stay on task and build deep focus.',
    badge: 'Wellness',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-4',
    type: 'app',
    title: 'Sleep Tracker Pro',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20sleep%20tracking%20health%20app%2C%20deep%20midnight%20navy%20and%20purple%20starfield%20gradient%20background%2C%20white%20moon%20with%20sleep%20wave%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20calm%20relaxing%20aesthetic&width=400&height=400&seq=app-sleep-tracker&orientation=squarish',
    price: '$3.99',
    priceNum: 3.99,
    category: 'app',
    subCategory: 'Health & Fitness',
    description: 'Automatic Apple Watch sleep tracking with heart rate and HRV analysis. Wake up with full insights into your sleep quality every morning.',
    badge: 'Apple Watch',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-5',
    type: 'app',
    title: 'Recipe Vault',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20recipe%20manager%20and%20cooking%20app%2C%20warm%20tomato%20red%20and%20golden%20orange%20gradient%20background%2C%20white%20chef%20hat%20or%20fork%20and%20spoon%20icon%2C%20minimal%20clean%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20food%20and%20culinary%20aesthetic&width=400&height=400&seq=app-recipe-vault&orientation=squarish',
    price: '$4.99',
    priceNum: 4.99,
    category: 'app',
    subCategory: 'Food & Drink',
    description: 'Save recipes from any website, auto-scale ingredients for any serving size, and build smart grocery lists automatically.',
    badge: 'Food & Drink',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-6',
    type: 'app',
    title: 'Star Walk Pro',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20augmented%20reality%20star%20gazing%20astronomy%20app%2C%20deep%20space%20dark%20navy%20and%20nebula%20purple%20gradient%2C%20white%20constellation%20star%20cluster%20icon%2C%20minimal%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20cosmos%20and%20universe%20aesthetic&width=400&height=400&seq=app-star-walk&orientation=squarish',
    price: '$2.99',
    priceNum: 2.99,
    category: 'app',
    subCategory: 'Education',
    description: 'Point your phone at the sky and instantly see stars, planets, constellations, and satellites overlaid in stunning augmented reality.',
    badge: 'AR + Education',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-7',
    type: 'app',
    title: 'Guitar Tuner Pro',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20guitar%20tuner%20and%20metronome%20music%20app%2C%20rich%20deep%20burgundy%20and%20warm%20amber%20gradient%2C%20white%20guitar%20tuning%20fork%20or%20music%20note%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20music%20and%20instrument%20aesthetic&width=400&height=400&seq=app-guitar-tuner&orientation=squarish',
    price: '$1.99',
    priceNum: 1.99,
    category: 'app',
    subCategory: 'Music',
    description: 'Chromatic tuner plus metronome plus full chord library — works completely offline for all instruments. Your pocket music studio.',
    badge: 'All Instruments',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-8',
    type: 'app',
    title: 'Weather Radar Ultra',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20live%20doppler%20weather%20radar%20and%20storm%20tracking%20app%2C%20electric%20blue%20and%20dark%20storm%20cloud%20gradient%2C%20white%20radar%20sweep%20or%20lightning%20bolt%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20meteorology%20and%20weather%20aesthetic&width=400&height=400&seq=app-weather-radar&orientation=squarish',
    price: '$3.99',
    priceNum: 3.99,
    category: 'app',
    subCategory: 'Weather',
    description: 'Live Doppler radar with real-time storm tracking and hyperlocal hourly forecasts. Know exactly what weather is heading your way.',
    badge: 'Live Radar',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-9',
    type: 'app',
    title: 'VPN Shield Pro',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20VPN%20security%20and%20privacy%20app%2C%20dark%20charcoal%20and%20electric%20green%20gradient%2C%20white%20shield%20with%20lock%20icon%2C%20minimal%20clean%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20cybersecurity%20and%20privacy%20aesthetic&width=400&height=400&seq=app-vpn-shield&orientation=squarish',
    price: '$4.99',
    priceNum: 4.99,
    category: 'app',
    subCategory: 'Utilities',
    description: 'One-tap VPN connection with 50+ global server locations, strict no-logs policy, and 256-bit military-grade encryption.',
    badge: '50+ Servers',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-10',
    type: 'app',
    title: 'Flashcard Master',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20spaced%20repetition%20flashcard%20study%20app%2C%20bright%20yellow%20and%20warm%20amber%20gradient%2C%20white%20flashcard%20with%20brain%20or%20lightbulb%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20education%20and%20learning%20aesthetic&width=400&height=400&seq=app-flashcard-master&orientation=squarish',
    price: '$2.99',
    priceNum: 2.99,
    category: 'app',
    subCategory: 'Education',
    description: 'Scientifically proven spaced repetition flashcard system. Import any deck, sync across devices, and master anything faster.',
    badge: 'Study Aid',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-11',
    type: 'app',
    title: 'Gut Health Tracker',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20gut%20health%20and%20digestive%20wellness%20tracking%20app%2C%20soft%20sage%20green%20and%20mint%20gradient%2C%20white%20leaf%20or%20digestive%20system%20icon%2C%20minimal%20clean%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20health%20and%20wellness%20aesthetic&width=400&height=400&seq=app-gut-health&orientation=squarish',
    price: '$3.99',
    priceNum: 3.99,
    category: 'app',
    subCategory: 'Health & Fitness',
    description: 'Track meals, symptoms, and bowel health patterns. Generate doctor-shareable PDF reports for IBS and digestive condition management.',
    badge: 'Doctor Reports',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-12',
    type: 'app',
    title: 'Habit Streaks',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20daily%20habit%20tracking%20with%20streaks%20app%2C%20vibrant%20coral%20and%20sunset%20orange%20gradient%2C%20white%20flame%20or%20chain%20link%20streak%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20lifestyle%20and%20motivation%20aesthetic&width=400&height=400&seq=app-habit-streaks&orientation=squarish',
    price: '$1.99',
    priceNum: 1.99,
    category: 'app',
    subCategory: 'Health & Wellness',
    description: 'Build powerful daily habits with visual streak tracking, Apple Watch complications, and Siri shortcut integration.',
    badge: 'Apple Watch',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-13',
    type: 'app',
    title: 'Content Blocker Pro',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20ad%20and%20tracker%20content%20blocker%20privacy%20app%2C%20clean%20slate%20grey%20and%20white%20gradient%2C%20white%20shield%20with%20X%20or%20blocked%20symbol%20icon%2C%20minimal%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20privacy%20and%20digital%20safety%20aesthetic&width=400&height=400&seq=app-content-blocker&orientation=squarish',
    price: '$1.99',
    priceNum: 1.99,
    category: 'app',
    subCategory: 'Utilities',
    description: 'Block ads, trackers, and popups across all Safari browsing. Privacy-first, extremely lightweight, and blazing fast.',
    badge: 'Privacy First',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-14',
    type: 'app',
    title: 'Mountain Guide AR',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20augmented%20reality%20mountain%20guide%20and%20peak%20finder%20travel%20app%2C%20crisp%20alpine%20blue%20and%20snow%20white%20gradient%2C%20white%20mountain%20peak%20with%20AR%20viewfinder%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20outdoor%20adventure%20aesthetic&width=400&height=400&seq=app-mountain-guide&orientation=squarish',
    price: '$3.99',
    priceNum: 3.99,
    category: 'app',
    subCategory: 'Travel',
    description: 'Point your camera at any mountain range and instantly see peak names in stunning augmented reality. Includes offline maps and GPS tracking.',
    badge: 'AR + Offline',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-15',
    type: 'app',
    title: 'Secure Messenger',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20end-to-end%20encrypted%20private%20messaging%20app%2C%20dark%20charcoal%20and%20electric%20teal%20gradient%2C%20white%20padlock%20with%20chat%20bubble%20icon%2C%20minimal%20clean%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20privacy%20and%20security%20aesthetic&width=400&height=400&seq=app-secure-messenger&orientation=squarish',
    price: '$2.99',
    priceNum: 2.99,
    category: 'app',
    subCategory: 'Social',
    description: 'End-to-end encrypted messaging with no phone number required and self-destructing messages. True privacy, always.',
    badge: 'E2E Encrypted',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-16',
    type: 'app',
    title: 'GTD Task Manager',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20Get%20Things%20Done%20GTD%20productivity%20task%20manager%20app%2C%20clean%20minimal%20charcoal%20and%20warm%20sand%20gradient%2C%20white%20checkmark%20with%20organized%20list%20icon%2C%20minimal%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20productivity%20and%20focus%20aesthetic&width=400&height=400&seq=app-gtd-task&orientation=squarish',
    price: '$4.99',
    priceNum: 4.99,
    category: 'app',
    subCategory: 'Productivity',
    description: 'Full Get-Things-Done methodology in your pocket. Manage projects, areas, deadlines, and tasks with Apple Watch integration.',
    badge: 'GTD Method',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-17',
    type: 'app',
    title: 'AI Writing Coach',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20AI-powered%20writing%20assistant%20and%20grammar%20coach%20app%2C%20vibrant%20indigo%20and%20warm%20gold%20gradient%2C%20white%20pen%20with%20sparkle%20AI%20stars%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20writing%20and%20creativity%20aesthetic&width=400&height=400&seq=app-ai-writing&orientation=squarish',
    price: '$2.99',
    priceNum: 2.99,
    category: 'app',
    subCategory: 'Productivity',
    description: 'AI-powered writing assistant that breaks down complex tasks, fixes grammar, checks tone, and helps you write better — faster.',
    badge: 'AI-Powered',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-18',
    type: 'app',
    title: 'Watermelon Merge',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20casual%20fruit%20merging%20puzzle%20game%20app%2C%20bright%20fun%20watermelon%20green%20and%20red%20gradient%2C%20white%20cute%20watermelon%20slice%20icon%2C%20playful%20minimal%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20casual%20gaming%20and%20fun%20aesthetic&width=400&height=400&seq=app-watermelon&orientation=squarish',
    price: '$0.99',
    priceNum: 0.99,
    category: 'app',
    subCategory: 'Games',
    description: 'Merge fruit puzzle game with an Apple Watch companion app. Relaxing, addictive, and perfect for short breaks throughout the day.',
    badge: 'Apple Watch',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-19',
    type: 'app',
    title: 'ID Verify Tool',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20business%20ID%20verification%20and%20age%20verification%20scanner%20app%2C%20professional%20dark%20navy%20and%20metallic%20silver%20gradient%2C%20white%20ID%20card%20with%20scan%20lines%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20business%20and%20security%20aesthetic&width=400&height=400&seq=app-id-verify&orientation=squarish',
    price: '$4.99',
    priceNum: 4.99,
    category: 'app',
    subCategory: 'Business',
    description: 'Scan and verify government IDs, driver licenses, and perform age verification instantly for businesses requiring compliance.',
    badge: 'Business Tool',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-20',
    type: 'app',
    title: 'Photo Editor Pro',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20professional%20photo%20editing%20app%2C%20vibrant%20gradient%20rainbow%20prism%20spectrum%20background%2C%20white%20camera%20lens%20aperture%20icon%2C%20minimal%20clean%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20photography%20and%20creative%20aesthetic&width=400&height=400&seq=app-photo-editor&orientation=squarish',
    price: '$2.99',
    priceNum: 2.99,
    category: 'app',
    subCategory: 'Photo & Video',
    description: 'Pro-grade mobile photo editing with full RAW support, curves, HSL color grading, and a library of professional presets.',
    badge: 'RAW Support',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-21',
    type: 'app',
    title: 'Property Analyzer',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20real%20estate%20investment%20calculator%20and%20property%20analysis%20app%2C%20professional%20slate%20grey%20and%20warm%20gold%20gradient%2C%20white%20house%20with%20graph%20chart%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20real%20estate%20and%20finance%20aesthetic&width=400&height=400&seq=app-property-analyzer&orientation=squarish',
    price: '$4.99',
    priceNum: 4.99,
    category: 'app',
    subCategory: 'Business',
    description: 'Real estate investment calculator for cap rate, cash-on-cash return, and ROI analysis. Purpose-built for eXp agents and investors.',
    badge: 'eXp Agents',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-22',
    type: 'app',
    title: 'AI Book Summary',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20AI-powered%20book%20summary%20and%20audio%20playback%20education%20app%2C%20rich%20deep%20teal%20and%20warm%20amber%20gradient%2C%20white%20open%20book%20with%20AI%20sparkle%20brain%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20education%20and%20reading%20aesthetic&width=400&height=400&seq=app-ai-book-summary&orientation=squarish',
    price: '$3.99',
    priceNum: 3.99,
    category: 'app',
    subCategory: 'Education',
    description: 'AI-powered summaries of top books with audio playback. Linked directly to the AI Book Authority catalog for seamless reading.',
    badge: 'Audio + AI',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-23',
    type: 'app',
    title: 'Digital Product Hub',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20digital%20product%20store%20and%20creator%20monetization%20app%2C%20vibrant%20purple-free%20bold%20red%20and%20orange%20gradient%2C%20white%20storefront%20or%20download%20arrow%20icon%2C%20minimal%20modern%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20digital%20commerce%20aesthetic&width=400&height=400&seq=app-digital-hub&orientation=squarish',
    price: '$4.99',
    priceNum: 4.99,
    category: 'app',
    subCategory: 'Business',
    description: 'Sell eBooks, templates, and online courses directly from your iPhone. Perfect for AI Digital Authority creators and content entrepreneurs.',
    badge: 'Creator Tool',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-24',
    type: 'app',
    title: 'Travel Planner AI',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20AI%20travel%20planning%20and%20trip%20itinerary%20builder%20app%2C%20vibrant%20sky%20blue%20and%20sandy%20warm%20gradient%2C%20white%20airplane%20or%20compass%20with%20map%20pin%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20travel%20and%20adventure%20aesthetic&width=400&height=400&seq=app-travel-planner&orientation=squarish',
    price: '$2.99',
    priceNum: 2.99,
    category: 'app',
    subCategory: 'Travel',
    description: 'AI-powered trip planning with smart itinerary building, expense tracking, and offline maps for seamless travel anywhere in the world.',
    badge: 'AI-Powered',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
  {
    id: 'app-25',
    type: 'app',
    title: 'Construction Calc Pro',
    image: 'https://readdy.ai/api/search-image?query=iOS%20app%20icon%20for%20construction%20estimating%20and%20project%20management%20calculator%20app%2C%20solid%20dark%20charcoal%20and%20bright%20yellow%20hard%20hat%20gradient%2C%20white%20ruler%20and%20hammer%20construction%20icon%2C%20minimal%20clean%20design%2C%20app%20store%20quality%20rounded%20square%20shape%2C%20construction%20and%20contractor%20aesthetic&width=400&height=400&seq=app-construction-calc&orientation=squarish',
    price: '$9.99',
    priceNum: 9.99,
    category: 'app',
    subCategory: 'Business',
    description: 'Construction estimating, materials calculators, and project timeline tools for contractors. Purpose-built for real estate development pros.',
    badge: 'Contractors',
    paymentLink: GODADDY_PAYMENT_LINK,
  },
];

export const appSubCategories = [
  'All Apps',
  'Productivity',
  'Health & Fitness',
  'Health & Wellness',
  'Education',
  'Business',
  'Utilities',
  'Travel',
  'Games',
  'Music',
  'Weather',
  'Social',
  'Food & Drink',
  'Photo & Video',
];

export const bookSubCategories = [
  'All Books',
  'AI & Technology',
  'Finance & Banking',
  'Business Development',
  'Real Estate',
  'Personal Growth',
  'Cooking & Food',
];
